import React from "react";
import FeatureBlock from "./FeatureBlock";
import { FaGlobe, FaShieldAlt, FaHeadset, FaCertificate } from "react-icons/fa";

const FeatureSection = () => (
    <div className="dg__live__chart bg__color--4 pt--30 pl--30 pr--30">
        <div className="row">
            <div className="col-md-3">
                <FeatureBlock 
                    icon={FaGlobe} 
                    title="Beginner-Focused Learning" 
                    // text="Step-by-step resources that turn market concepts into clear understanding."
                />
            </div>
            <div className="col-md-3">
                <FeatureBlock 
                    icon={FaShieldAlt} 
                    title="Secure & Transparent" 
                    // text="Your safety comes first. Trade confidently with strong encryption and fair practices."
                />
            </div>
            <div className="col-md-3">
                <FeatureBlock 
                    icon={FaHeadset} 
                    title="All-in-One Platform" 
                    // text="Access Forex, Crypto, and Stock trading — all from one intuitive dashboard."
                />
            </div>
            <div className="col-md-3">
                <FeatureBlock 
                    icon={FaCertificate} 
                    title="PCI DSS certified" 
                    // text="Learn, trade, and grow with the mentorship of experienced traders."
                />
            </div>
        </div>
    </div>
);

export default FeatureSection;
